let initState = {

};


export default function storyReducer(state = initState, action) {

    switch (action.type) {
        case "UPDATE_STORY_PARAMS": return {
            ...state
        };
        default:
            return state;
    }

}